/* eslint-disable no-undef */

import React, { PureComponent } from 'react'
import { withStyles } from '@material-ui/core/styles/index'
import parse from 'html-react-parser'
import { Typography } from '@material-ui/core'

const styles = theme => ({
    headerWrapper: {
        marginTop: -16
    },
    title: {
        margin: 0,
        paddingTop: theme.title.paddingTop - 8 + 'px!important',
        paddingBottom: theme.title.paddingBottom - 8 + 'px!important',
        textTransform: theme.title.textTransform,
        [theme.breakpoints.up(600)]: {
            paddingTop: theme.title.paddingTop + 'px!important',
            paddingBottom: theme.title.paddingBottom + 'px!important'
        },
        color: theme.header?.color && theme.header.color + '!important',
        //textTransform: 'uppercase',
        textShadow: 'none!important',
        marginTop: theme.layoutAlias === 'exclusive' ? '0!important' : 'inherit'
    },
    emptyTitle: {
        paddingTop: '0!important',
        paddingBottom: '20px!important'
    },
    description: {
        paddingTop: 0,
        paddingBottom: 0,
        marginBottom: theme.description.marginBottom,
        [theme.breakpoints.up(600)]: {
            paddingBottom: theme.spacing(1),
            marginBottom: theme.description.marginBottom
        },
        fontSize: '0.98rem'
    },
    emptyDescription: {
        paddingTop: 0,
        paddingBottom: 0,
        marginBottom: theme.description.emptyMarginBottom
    }
})

class QuestionPageHeader extends PureComponent {
    render() {
        const { questionPage, theme, classes } = this.props

        const isSignupPage = questionPage.isSignupPage
        const isExclusiveTheme = theme?.layout === 'exclusive'

        let title = questionPage.title
        let description = questionPage.description

        if (isSignupPage && isExclusiveTheme) {
            title = ''
            description = ''
        }

        if (isSignupPage && !isExclusiveTheme && theme.themeHeader) {
            title = theme.themeHeader
            description = theme.themeDescription
        }

        return (
            <div className={classes.headerWrapper + ' questionPageHeader'}>
                <Typography
                    component="h4"
                    variant={questionPage.titleSize}
                    align="center"
                    className={classes.title + ' ' + (!questionPage.title ? classes.emptyTitle : '')}
                >
                    {title && parse(title)}
                </Typography>
                {description && (
                    <Typography variant="body1" align="center" color="textSecondary" className={classes.description}>
                        {parse(description)}
                    </Typography>
                )}
                {!description && <Typography variant="body1" align="center" color="textSecondary" className={classes.emptyDescription} />}
            </div>
        )
    }
}

export default withStyles(styles)(QuestionPageHeader)
